export const NAVBAR_HEIGHT = "80px";
export const NAVIGATION_HEIGHT = "120px";
